export interface OnboardingData {
  email: string;
  username: string;
  displayName: string;
  bio: string;
  photoUrl: string | null;
  notifAllowed: boolean | null;
}

export interface Step {
  id: string;
  title: string;
  group: string;
}

export interface WizardCtx {
  data: OnboardingData;
  update: (patch: Partial<OnboardingData>) => void;
  next: () => void;
  back: () => void;
  stepIdx: number;
  steps: Step[];
}

export const STEPS: Step[] = [
  { id: 'welcome',  title: 'Welcome',        group: 'Get started' },
  { id: 'signup',   title: 'Create account', group: 'Get started' },
  { id: 'verify',   title: 'Verify email',   group: 'Get started' },
  { id: 'profile',  title: 'Your profile',   group: 'Profile' },
  // 'notif' step temporarily hidden — backend has no endpoint to persist
  // notification preferences yet. NotifStep.tsx is kept around for when
  // it's needed.
  { id: 'done',     title: "You're in",      group: 'Almost there' },
];
